import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./resources/en";
import hi from "./resources/hi";
import es from "./resources/es";
import ja from "./resources/ja";
import de from "./resources/de";
import fr from "./resources/fr";
import hr from "./resources/hr";
import pl from "./resources/pl";
import ro from "./resources/ro";
import sk from "./resources/sk";
import sv from "./resources/sv";
import uk from "./resources/uk";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES
} from "./languages";

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  es: { translation: es },
  ja: { translation: ja },
  de: { translation: de },
  fr: { translation: fr },
  hr: { translation: hr },
  pl: { translation: pl },
  ro: { translation: ro },
  sk: { translation: sk },
  sv: { translation: sv },
  uk: { translation: uk }
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"]
    }
  });

export default i18n;
